import React from 'react';
import {
  Flex,
  ScrollView,
  StackScreen,
} from '@banhala/ui-kit';
import { useHandleBackPressed } from 'shared/src/hooks/useHandleBackPressed';
import { isIOS } from 'shared/src/utils';
import { useMyPageRoute } from '../../hooks/useMyPageRoute';
import { useSetScreenName } from '../../hooks/useSetScreenName';
import { CartIcon } from 'shared/src/component/CartIcon';
import { Image } from 'react-native';
import { LaboratorySwitch } from './components/LaboratorySwitch';
import { useLaboratorySetting } from './hooks/useLaboratorySetting';
import { useLogViewLaboratory } from './hooks/useLogViewLaboratory';
import { SearchIcon } from 'shared/src/component';

const Laboratory = () => {
  const { params } = useMyPageRoute<'Laboratory'>();
  const { instanceId } = params;
  const { showBackButton, onPressBack } = useHandleBackPressed(instanceId);

  const { isOn: isLikeFolderOn, setIsOn: setIsLikeFolderOn } = useLaboratorySetting('IS_LIKE_FOLDER');
  const { isOn: isLGifImageOn, setIsOn: setIsLGifImageOn } = useLaboratorySetting('IS_GIF_IMAGE');
  const { isOn: isTouchVibrationOn, setIsOn: setIsTouchVibrationOn } = useLaboratorySetting('IS_TOUCH_VIBRATION');
  const { isOn: isScreenShotShareOn, setIsOn: setIsScreenShotShareOn } = useLaboratorySetting('IS_SELECT_GOODS_SCREEN_SHOT_SHARE');

  useLogViewLaboratory({
    IS_LIKE_FOLDER: isLikeFolderOn,
    IS_GIF_IMAGE: isTouchVibrationOn,
    IS_TOUCH_VIBRATION: isLGifImageOn,
    IS_AFTER_SCREEN_CAPTURE_SHARE: isScreenShotShareOn,
  });

  useSetScreenName('Laboratory');

  return (
    <StackScreen
      title="실험실"
      hideBackButton={!showBackButton}
      onPressBack={onPressBack}
      rightIcons={[
        <SearchIcon screen="LABORATORY" />,
        <CartIcon screen="LABORATORY" />,
      ]}
    >
      <ScrollView>
        <Flex padding={{ vertical: 24 }} alignItems="center">
          <Image
            source={require('./images/img_lab.png')}
            style={{ height: 104 }}
            resizeMode="contain"
          />
        </Flex>

        <LaboratorySwitch
          laboratoryKey="IS_LIKE_FOLDER"
          isOn={isLikeFolderOn ?? false}
          onChange={setIsLikeFolderOn}
        />
        <LaboratorySwitch
          laboratoryKey="IS_GIF_IMAGE"
          isOn={isLGifImageOn ?? false}
          onChange={setIsLGifImageOn}
        />
        {isIOS && (
          <LaboratorySwitch
            laboratoryKey="IS_TOUCH_VIBRATION"
            isOn={isTouchVibrationOn ?? false}
            onChange={setIsTouchVibrationOn}
          />
        )}
        <LaboratorySwitch
          laboratoryKey="IS_SELECT_GOODS_SCREEN_SHOT_SHARE"
          isOn={isScreenShotShareOn ?? false}
          onChange={setIsScreenShotShareOn}
        />
      </ScrollView>
    </StackScreen>
  );
};
export default Laboratory;